export const REQUIRED_MESSAGE = 'field is required';
export const EMAIL_MESSAGE = 'enter correct email';
